var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"days"},[_c('Query',{attrs:{"query":_vm.query,"variables":{ languageID: _vm.languageID }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var repositories = ref.repositories;
return _vm._l((_vm.repositoriesToDays(repositories)),function(day){return _c('Day',_vm._b({key:day.date.toDateString()},'Day',day,false))})}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }